import React, { useState, useEffect } from "react";

const CountdownTimer = (props) => {
    const { raceTime } = props;

    const calculateTimeLeft = () => {
        const targetDate = new Date(raceTime).getTime();
        const now = new Date().getTime();
        const difference = targetDate - now;

        if (difference <= 0) {
            return {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        return {
            days,
            hours,
            minutes,
            seconds,
        };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [raceTime]);

    // 格式化數字，補零到兩位數
    const formatNumber = (num) => String(num).padStart(2, "0");

    // 計算是否接近賽事（少於7天）
    const isUrgent = timeLeft.days < 7;

    return (
        <div className="CountdownTimer" aria-live="polite">
            <h6>距離比賽還剩</h6>
            <div className="timer-display">
                <div className={`timer-unit ${isUrgent ? "urgent" : ""}`}>
                    <div className="timer-value">{formatNumber(timeLeft.days)}</div>
                    <div className="timer-label">天</div>
                </div>
                <div className="timer-separator">:</div>
                <div className={`timer-unit ${isUrgent ? "urgent" : ""}`}>
                    <div className="timer-value">{formatNumber(timeLeft.hours)}</div>
                    <div className="timer-label">時</div>
                </div>
                <div className="timer-separator">:</div>
                <div className={`timer-unit ${isUrgent ? "urgent" : ""}`}>
                    <div className="timer-value">{formatNumber(timeLeft.minutes)}</div>
                    <div className="timer-label">分</div>
                </div>
                <div className="timer-separator">:</div>
                <div className={`timer-unit ${isUrgent ? "urgent" : ""}`}>
                    <div className="timer-value">{formatNumber(timeLeft.seconds)}</div>
                    <div className="timer-label">秒</div>
                </div>
            </div>
        </div>
    );
};

export default CountdownTimer;
